import { IsEnglish } from '../../../utils/language';


export function sortTask(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.taskEn.toLowerCase() : a.taskFr.toLowerCase()
        const nameB = IsEnglish() ? b.taskEn.toLowerCase() : b.taskFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortTaskByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.taskCode
        const nameB = b.taskCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}